// 新建newTemplate.art替换template.art作为全局pdf的模板
// import fwTemplateCompiler from './template.art';
import fwTemplateCompiler from './fwTemplate.art';
import templateMobileCompiler from "./fwTemplate.mobile.art";
// import templateMobileCompiler from "./template.mobile.art";
// import collaborationTemplate from "./collabration.art"
// import toolbar from "./toolbar.art"

import { isIE } from 'Utils/browser-info';
import {isMobile} from 'Utils/device';
// const template = (isMobile)? templateMobileCompiler(): fwTemplateCompiler({ isIE });
const template = (isMobile)? templateMobileCompiler() : fwTemplateCompiler({ isIE });
export function ViewerTemplateModule(/* callback */) {
    const viewerTemplate = {
        fragments:[],
        template,
        // toolbar:toolbar(),
        collab: template,
    };
    
    return viewerTemplate;
}


// import templateCompiler from './template.art';
// import templateMobileCompiler from "./template.mobile.art";
// import toolbar from "./toolbar.art"

// import { isIE } from 'Utils/browser-info';
// import {isMobile} from 'Utils/device';
// const template = (isMobile) ? templateMobileCompiler({ normalMode: true }) : templateCompiler({ isIE, normalMode: true });
// export function ViewerTemplateModule(/* callback */) {
//     const viewerTemplate = {
//         fragments:[],
//         template,
//         toolbar:toolbar(),
//         collab:templateCompiler(),
//     };

//     return viewerTemplate;
// }


